import React, { useState, useEffect, useContext, useRef } from 'react';

import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import QuotationService from "../Controller/QuotationController";
import QuotationDetailModal from "./QuotationDetail";
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import IssuePriorityService from "../../Setup/controller/IssuePriorityController/IssuePriorityController";
import IssueStatusService from "../../Setup/controller/IssueStatusController/IssueStatusController";
import ProjectCategoryService from "../../Setup/controller/ProjectCategoryController/ProjectCategoryController";
import ProjectService from "../../Setup/controller/ProjectMemberController/ProjectMemberController";

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import useServiceJob from "./QuotationForms/useServiceJob"
import useSaleOrder from "./QuotationForms/useSaleOrder";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import SendEmail from "../../Common/SendEmail";
import MultipleEmail from "../../Common/MultipleEmail";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import SendAttachment from "../../Common/SendAttachment";
import { handleSubmit as handleCustomerSubmit } from "../../Customer/Controller/CreateCustomerDetailController";
import OppurtunityService from "../../Oppurtunity/Controller/OppurtunityController"
import useInvoice from "./QuotationForms/useInvoice";
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
function QuotationList({ ClientCompanyID, LeadID, OpportunityID, MainPage }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
    return { date, time };
  };
  const { date, time } = getCurrentDateTime();
  const tableRef = useRef();
  const FormAction = "/QuotationsList";
  //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);

  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [QuotationList, setQuotationData] = useState([]);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [selectedParts, setSelectedParts] = useState([]);

  const [ProjectCategoryList, setProjectCategory] = useState([]);
  const [ProjectMemberList, setProjectMember] = useState([]);
  const [IssuePriorityList, setIssuePriority] = useState([]);
  const [IssueStatusList, setIssueStatus] = useState([]);
  const [typeOfCustomer, setTypeOfCustomer] = useState([]);
  const [selectedId, setSelectedId] = useState("0");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [multipleIds, setMultipleIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const CompanyID = localStorage.getItem("CompanyID");
  const UserID = localStorage.getItem("UserID");
  const [recentSearches, setRecentSearches] = useState([]);
  const activeDateFormat = useDateFormat();
  const [pdfAttachment, setPdfAttachment] = useState(null);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`QuotationSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`QuotationSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'PK_Quotation_ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());



  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("6");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };

  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

  useEffect(() => {
    fetchSearchLog();
    fetchQuotation(currentPage, pageSize);
  }, [currentPage, pageSize]);
  useEffect(() => {
    fetchQuotation(currentPage, pageSize);
  }, [sortConfig]);

  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");


    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };



  const fetchQuotation = async (page, size) => {
    try {
      setLoading(true);

      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();

      const quotationData = await QuotationService.GetAllNewQuotations(redirectCallback, ClientCompanyID, LeadID, OpportunityID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());
      setQuotationData(quotationData);
      localStorage.setItem('QuotationID', "0");

      const leadCount = await QuotationService.GetQuotationCount(redirectCallback, ClientCompanyID, LeadID, OpportunityID, searchQuery, searchColumns.toString());
      setPOCount(leadCount[0].TotalRecords);
      setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  const fetchProject = async () => {
    try {

      const redirectCallback = () => navigate('/');
      const list = await ProjectService.GetProjectMemberByID(redirectCallback);
      const DefaultProjectList = list[0].filter(project => project.IsDefault == 1);
      if (DefaultProjectList.length > 0) {
        return DefaultProjectList[0].ID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };
  const fetchProjectCategory = async (ProjectID) => {
    try {
      setProjectCategory([]);
      const redirectCallback = () => navigate('/');
      const list = await ProjectCategoryService.GetAllProjectCategories(redirectCallback, ProjectID);
      const defaultCategory = list.find(priority => priority.IsDefault === 1);
      if (defaultCategory) {
        return defaultCategory.ProjectCategoriesID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching customer contacts:', error);
    }
  };
  const fetchIssuePriority = async () => {
    try {

      const redirectCallback = () => navigate('/');
      const list = await IssuePriorityService.GetAllIssuePriority(redirectCallback);
      const defaultPriority = list.find(priority => priority.IsDefault === 1);
      if (defaultPriority) {
        return defaultPriority.ID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching issue priorities:', error);
    }
  };
  const fetchIssueStatus = async () => {
    try {

      const redirectCallback = () => navigate('/');
      const list = await IssueStatusService.GetAllIssueStatus(redirectCallback);
      const defaultStatus = list.find(status => status.IsDefault === 1);
      if (defaultStatus) {
        return defaultStatus.ID;
      }
      else {
        return "0";
      }
    } catch (error) {
      console.error('Error fetching issue statuses:', error);
    }
  };
  useEffect(() => {
    UserLockRelease();
    IsModuleAssigned();
    localStorage.setItem('QuotationID', "");
    localStorage.setItem('QuotationID', "0");
    fetchQuotation("0", pageSize);
  }, [ClientCompanyID, LeadID, OpportunityID]);

  const handleCloseModal = async (isChanged) => {


    const closeModal = async () => {
      await QuotationService.UnLockQuotation(localStorage.getItem('QuotationID'));
      localStorage.setItem('QuotationID', "0");
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      setMultipleIds([]);
      fetchQuotation("0", pageSize);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };
  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await QuotationService.DeleteQuotation(multipleIds, typeOfCustomer);
            setMultipleIds([]);
            fetchQuotation("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete quotation.',
        'warning'
      );
    }
  };
  const handleCreateQuotationClick = () => {

    localStorage.setItem('QuotationID', "");
    localStorage.setItem('QuotationID', "0");
    localStorage.setItem('CustomerType', "");
    localStorage.setItem('HasRecordUpdated', "0");

    setIsModalOpen(true);
  };

  const handleEditClick = async (QuotationID, CustomerType) => {
    const IsAlreadyLeadID = localStorage.getItem('QuotationID');
    if (IsAlreadyLeadID) {
      await QuotationService.UnLockQuotation(IsAlreadyLeadID);
    }
    const quotationDetail = await fetchQuotationDetail(QuotationID, CustomerType);
    if (quotationDetail.length > 0) {
      localStorage.setItem('QuotationID', "");
      localStorage.setItem('QuotationID', QuotationID);
      localStorage.setItem('CustomerType', CustomerType);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(QuotationID);
      setIsModalOpen(true);

    }
  };
  const { handleServiceJob } = useServiceJob(setLoading, setSelectedParts, tableRef, fetchQuotation);
  const handleCreateServiceJob = async (event) => {
    debugger;
    if (multipleIds.length > 0) {
      for (const id of multipleIds) {
        const QuotationID = id;
        if (QuotationID > 0) {

          const quotationDetail = await fetchQuotationDetail(QuotationID);
          if (quotationDetail[0].FK_Issue_ID > 0 || quotationDetail[0].FK_SalesOrder_ID > 0) {
            Swal.fire(
              'Error!',
              'Sale Order or Service job already exist for the selected quotation.',
              'warning'
            );
          }
          else {

            const result = await Swal.fire({
              title: 'Are you sure?',
              text: "Create service job from the selected quotation!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Create it!'
            });

            if (result.isConfirmed) {
              if (quotationDetail[0].OpportunityID > 0) {
                const Customer = await CreateCustomer(event, quotationDetail[0].OpportunityID, "0");

              }
              const message = await handleServiceJob(event, QuotationID);
              if (message === "Data Saved") {
                Swal.fire(
                  'Success!',
                  'Serviec Job Created Successfully.',
                  'success'
                );
                await fetchQuotation("0", pageSize);
              }
            }
          }


        }

      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to create a service job.',
        'warning'
      );
    }
  };

  const { handleSaleOrder } = useSaleOrder(setLoading, setSelectedParts, tableRef, fetchQuotation);
  const handleCreateSaleOrder = async (event) => {
    if (multipleIds.length > 0) {
      for (const id of multipleIds) {
        const QuotationID = id;
        if (QuotationID > 0) {

          const quotationDetail = await fetchQuotationDetail(QuotationID);
          if (quotationDetail[0].FK_Issue_ID > 0 || quotationDetail[0].FK_SalesOrder_ID > 0) {
            Swal.fire(
              'Error!',
              'Sales Order or Service job already exist for the selected quotation.',
              'warning'
            );
          }
          else {
            const result = await Swal.fire({
              title: 'Are you sure?',
              text: "Create sales order from the selected quotation!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Create it!'
            });

            if (result.isConfirmed) {
              debugger;
              if (quotationDetail[0].OpportunityID > 0) {
                const Customer = await CreateCustomer(event, quotationDetail[0].OpportunityID, "0");

              }
              const message = await handleSaleOrder(event, QuotationID);
              if (message === "Data Saved") {
                Swal.fire(
                  'Success!',
                  'Sales Order Created Successfully.',
                  'warning'
                );
                await fetchQuotation("0", pageSize);

              }
            }
          }

        }

      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to create  sales order.',
        'warning'
      );
    }
  };


  const fetchQuotationDetail = async (QuotationID, CustomerType = 1) => {
    try {
      const redirectCallback = () => navigate('/');
      const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, QuotationID, CustomerType);
      return quotationDetail;
    } catch (error) {
      console.error('Error fetching agreement details:', error);
    }
  };
  const fetchQuotationItems = async (QuotationID, currencySymbol, ConversionRate) => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const quotationDetails = await QuotationService.GetQuotationItem(redirectCallback, QuotationID);

      const selectedPartsData = await Promise.all(quotationDetails.map(async (detail) => {
        const convertedStockPrice = parseFloat(detail.mon_StockPrice * ConversionRate).toFixed(2);
        const convertedmon_SalesPrice = parseFloat(detail.mon_SalesPrice * ConversionRate).toFixed(2);
        const converteddec_VAT = parseFloat(detail.dec_VAT * ConversionRate).toFixed(2);
        const converteddec_Quantity = parseFloat(detail.dec_Quantity * ConversionRate).toFixed(2);
        const convertednet_SalesPrice = parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2);
        const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
        const convertedmon_SellingPrice = parseFloat(detail.mon_SellingPrice * ConversionRate).toFixed(2);
        const convertedmon_dec_Allocated = parseFloat(detail.dec_Allocated * ConversionRate).toFixed(2);
        const convertedmon_dec_FreeStock = parseFloat(detail.dec_FreeStock * ConversionRate).toFixed(2);
        const convertedmon_mon_AverageCostPrice = parseFloat(detail.mon_AverageCostPrice * ConversionRate).toFixed(2);

        return {
          vc_StockCode: detail.vc_StockCode,
          vc_Description: detail.vc_Description,
          mon_StockPrice: convertedStockPrice, // Use the converted price
          mon_SalesPrice: convertedmon_SalesPrice,
          dec_Quantity: detail.dec_Quantity,
          vc_UnitOfSale: detail.vc_UnitOfSale,
          net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
          net_VATPrice: parseFloat(converteddec_VAT).toFixed(2),
          vc_StockName: detail.vc_Description,
          PK_Stock_ID: detail.FK_Stock_ID,
          dec_Discount: detail.dec_Discount,
          mon_SellingPrice: convertedmon_SalesPrice,
          dec_Allocated: convertedmon_dec_Allocated,
          dec_FreeStock: convertedmon_dec_FreeStock,
          mon_AverageCostPrice: convertedmon_mon_AverageCostPrice,

          mon_NetPrice: parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2),
          mon_VATPrice: parseFloat(detail.net_VATPrice * ConversionRate).toFixed(2),
          mon_DiscountNetPrice: parseFloat(detail.dec_Discount * ConversionRate).toFixed(2),
          // Map other fields as needed
        };
      }));
      debugger;
      return selectedPartsData;

    } catch (error) {
      console.error('Error fetching supplier details:', error);
    }
  };

  const generatePDF = () => {
    debugger;
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text('Quotation List Report', 14, 22);

    // Add table using autoTable
    doc.autoTable({
      head: [['Quotation No', 'Quotation Date', 'Status', 'Customer', 'Address', 'Sales No', 'Job No', 'Total']],
      body: QuotationList.map(quotation => [
        quotation.bnt_OrderNumber,
        formatDate(quotation.dt_QuotationDate),
        truncateText(quotation.vc_StatusName),
        truncateText(quotation.BranchName),
        truncateText(quotation.vc_Address1),
        quotation.SaleOrderNo,
        quotation.JobNo,
        parseFloat(quotation.Total).toFixed(2)
      ]),
      startY: 30,
    });

    // Save the PDF
    doc.save('quotation_list_report.pdf');
  };

  const handleSuccess = () => {
    fetchQuotation("0", pageSize);
  }

  const truncateText = (text, maxLength = 15) => {
    if (typeof text !== 'string') {
      return ''; // Return an empty string if text is not a valid string
    }
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const handleCheckboxClick = (event, id, index, type) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = QuotationList.slice(start, end + 1).map(l => l.PK_Quotation_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
    setTypeOfCustomer(type);
  };


  const getSelectedId = () => {
    console.log(selectedId);
  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "6");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  const handlePageChange = (page) => {
    setQuotationData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setQuotationData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const leadData = await QuotationService.GetAllNewQuotations(redirectCallback, ClientCompanyID, LeadID, OpportunityID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setQuotationData(leadData);

    const leadCount = await QuotationService.GetQuotationCount(redirectCallback, ClientCompanyID, LeadID, OpportunityID, searchQuery, columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("6");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    debugger;
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await QuotationService.GetAllNewQuotations(redirectCallback, ClientCompanyID, LeadID, OpportunityID, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const porderCount = await QuotationService.GetQuotationCount(redirectCallback, ClientCompanyID, LeadID, OpportunityID, searchQuery, searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setQuotationData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "QquotationNo",
    "QquotationDate",
    "Qstatus",
    "Qtype",
    "Qcustomer",
    "QSiteName",
    "Qemail",
    "Qaddress",
    "QsalesNo",
    "QjobNo",
    "Qtotal",
    "ModifiedBy",
  ];

  const columnOptions = [
    { value: "QquotationNo", label: "Quotation No." },
    { value: "QquotationDate", label: "Quotation Date" },
    { value: "Qstatus", label: "	Status" },
    { value: "Qtype", label: "	Type" },
    { value: "Qcustomer", label: "Customer" },
    { value: "QSiteName", label: "SiteName" },
    { value: "Qemail", label: "Email" },
    { value: "Qaddress", label: "	Address" },
    { value: "QsalesNo", label: "Sales No." },
    { value: "QjobNo", label: "	Job No." },
    { value: "Qtotal", label: "	Total" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" }
  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`QuotationColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`QuotationColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };
  const handleDropdownChange = async (event, quotationId) => {
    event.stopPropagation();
    const selectedValue = event.target.value;

    try {
      const response = await QuotationService.UpdateQuotationConvertType(quotationId, selectedValue);

      if (response.message === "User added successfully") {
        // Update state immediately instead of waiting for fetch
        setQuotationData((prevData) =>
          prevData.map((quotation) =>
            quotation.PK_Quotation_ID === quotationId
              ? { ...quotation, ConvertType: selectedValue } // Update only changed dropdown
              : quotation
          )
        );

        // Swal.fire("Success", "Quotation updated successfully!", "success");
      } else {
        Swal.fire("Error", "Failed to update quotation!", "error");
      }
    } catch (error) {
      console.error("API error:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [Email, setEmail] = useState();
  const [ContactIDForEmail, setContactIDForEmail] = useState();
  const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
  const [multipleEmails, setMultipleEmails] = useState([]);
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
  const handleEmailClick = async (event, contact) => {
    event.stopPropagation();
    setEmail(contact.Email);
    setContactIDForEmail(contact.ClientContact_ID)
    setIsEmailModalOpen(true);
  };
  const handleCloseEmailModal = async () => {

    setIsEmailModalOpen(false);
    setIsMultipleEmailModalOpen(false);
    fetchQuotation("0", pageSize);
  };
  const handleSendMultipleEmail = async () => {
    if (multipleIds.length > 0) {
      const emails = multipleIds
        .map(id => {
          const contact = QuotationList.find(c => c.PK_Quotation_ID === id);
          return contact ? contact.Email : '';
        })
        .filter(email => email);

      setEmail(emails[0]);
      const id = multipleIds[0];
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const JasperReport = await JasperReportService.GetJasperReportByID("108");
      let url = JasperReport[0].Link;
      debugger;
      Object.keys(currentInputValues).forEach((key) => {
        const placeholder = new RegExp(`{${key}}`, "g");
        url = url.replace(placeholder, currentInputValues[key]);
      });

      const queryObj = {
        ...currentInputValues,
        format: "pdf",
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const queryString = new URLSearchParams(queryObj).toString();

      // 🔥 GET PDF as BLOB from API
      const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
        responseType: "blob",
      });

      // 🔥 Convert Blob → File
      const pdfFile = new File(
        [response.data],
        `${JasperReport[0].ReportName}.pdf`,
        { type: "application/pdf" }
      );

      // 🔥 Save to state (to send email)
      setPdfAttachment(pdfFile);

      // 🔥 Open Email Modal
      setIsMultipleEmailModalOpen(true);
    }
    else {
      Swal.fire('Error!', 'Please check at least one record.', 'warning');
    }
  }
  const defaultColumnsForSearch = [
    "QquotationNo",
    "QquotationDate",
    "Qstatus",
    "Qtype",
    "Qcustomer",
    "QSiteName",
    "Qemail",
    "Qaddress",
    "QsalesNo",
    "QjobNo",
    "Qtotal",
    "ModifiedBy"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "QquotationNo", label: "Quotation No." },
    { value: "QquotationDate", label: "Quotation Date" },
    { value: "Qstatus", label: "	Status" },
    { value: "Qtype", label: "	Type" },
    { value: "Qcustomer", label: "Customer" },
    { value: "QSiteName", label: "SiteName" },
    { value: "Qemail", label: "Email" },
    { value: "Qaddress", label: "	Address" },
    { value: "QsalesNo", label: "Sales No." },
    { value: "QjobNo", label: "	Job No." },
    { value: "Qtotal", label: "	Total" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" }

  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };
  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedJob = QuotationList.filter(job =>
        multipleIds.includes(job.PK_Quotation_ID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "QquotationNo") {
            value = `${row.bnt_OrderNumber ?? ""}`;
          }
          if (col === "QquotationDate") {
            value = `${row.dt_QuotationDate ?? ""}`;
          }
          if (col === "Qstatus") {
            value = `${row.vc_StatusName ?? ""}`;
          }
          if (col === "Qtype") {
            value = `${row.type ?? ""}`;
          }
          if (col === "Qcustomer") {
            value = `${row.CompanyName ?? ""}`;
          }
          if (col === "Qemail") {
            value = `${row.Email ?? ""}`;
          }
          if (col === "Qaddress") {
            value = `${row.vc_Address1 ?? ""}`;
          }
          if (col === "QsalesNo") {
            value = `${row.SaleOrderNo ?? ""}`;
          }
          if (col === "QjobNo") {
            value = `${row.JobNo ?? ""}`;
          }
          if (col === "Qtotal") {
            value = `${row.Total ?? ""}`;
          }

          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Quotations.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);
  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "6");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 108;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();

    const result = await Swal.fire({
      title: "Include Terms & Conditions?",
      text: "Do you want to include Terms & Conditions in the print?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, include it",
      cancelButtonText: "No, just main report",
    });
    setLoading(true);
    const includeTerms = result.isConfirmed;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));


          // ================= ADD TERMS ONLY ONCE =================
          if (includeTerms) {

            const companySetup = await CompanySetupController.GetCompanyByID(
              () => navigate('/'),
              localStorage.getItem("CompanyID")
            );

            const termFile = companySetup?.[0]?.TermFile;

            if (termFile) {
              const FileUrl = `${BASE_URL}/uploads/${localStorage.getItem('CompanyID')}/Admin/TermConditions/${termFile}`;

              const responseSecond = await axiosInstance.get(FileUrl, {
                responseType: 'blob'
              });

              const secondPdfBytes = await responseSecond.data.arrayBuffer();
              const secondPdf = await PDFDocument.load(secondPdfBytes);

              const secondPages = await finalMergedPdf.copyPages(
                secondPdf,
                secondPdf.getPageIndices()
              );

              secondPages.forEach(page => finalMergedPdf.addPage(page));
            }
          }
        }
        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };
  const handleStart = (e, ui) => {
    e.stopPropagation();
  }


  const getInitialWidths = () => {
    const saved = Cookies.get(`QuotColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`QuotColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [QuotationList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `QuotColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `QuotColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const CreateCustomer = async (event, OpportunityID, quotationID) => {
    const LeadDetail = await fetchOpportunityDetail(OpportunityID);
    debugger;
    //  if (LeadDetail.ClientCompanyID < 1) {

    const formData = {
      ClientCompanyID: 0,
      FK_ClientCompanyType_ID: 0,
      ContactTypeID: "1",

      FK_LeadOpportunitySource_Id: LeadDetail.FK_LeadOpportunitySource_Id,
      FK_LeadOpportunityStatus_ID: LeadDetail.FK_LeadOpportunityStatus_ID,
      FK_TaxCode_ID: LeadDetail.FK_TaxCode_Id,
      FK_Currency_ID: LeadDetail.FK_Currency_Id,
      FK_Owner_Id: LeadDetail.FK_Owner_Id,
      TeamID: 0,
      CourierID: 0,
      CompanyName: LeadDetail.vc_Company,
      Title: LeadDetail.vc_Title,
      Forename: LeadDetail.vc_FirstName,
      Surname: LeadDetail.vc_Surname,
      Telephone: LeadDetail.vc_Phone,
      Mobile: LeadDetail.vc_Mobile,
      Email: LeadDetail.vc_Email,
      Address1: LeadDetail.vc_Address1,
      Address2: LeadDetail.vc_Address2,
      Address3: LeadDetail.vc_Address3,
      City: LeadDetail.vc_City,
      County: LeadDetail.vc_County,
      Country: LeadDetail.vc_Country,
      Website: LeadDetail.vc_Website,
      dec_Weight: LeadDetail.dec_Weight,
      vc_Topic: LeadDetail.vc_Topic,
      quotationID: quotationID,
      IndustrialSector: LeadDetail.IndustrialSector,
      NoOfEmployees: LeadDetail.NoOfEmployees,
      PostCode: LeadDetail.vc_Postcode,
      JobRoleID: LeadDetail.JobRoleID,

    }

    const redirectCallback = () => {
      navigate('/'); // Redirect to the login page
    };
    formData.FromOpportunity = "1";
    formData.OpportunityID = OpportunityID;
    const formDataWithParts = {
      formData: formData,
      tableData: [],

    };
    const message = await handleCustomerSubmit(event, formDataWithParts, "", setErrors, redirectCallback, "", "1");
    debugger;
    return message;

  }
  const fetchOpportunityDetail = async (ID) => {
    try {

      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const OppDetail = await OppurtunityService.GetOppurtunityByID(redirectCallback, ID);

      OppDetail[0].CType = "Opportunity";
      OppDetail[0].CompanyName = OppDetail[0].vc_Company;
      return OppDetail[0];
    } catch (error) {
      console.error('Error fetching asset details:', error);
    }
  };

  const { handleInvoice } = useInvoice(setLoading, setSelectedParts, tableRef, []);
  const handleCreateInvoice = async (event) => {
    debugger;

    const redirectCallback = () => navigate('/');
    if (multipleIds.length > 0) {
      for (const id of multipleIds) {
        const QuotationID = id;
        if (QuotationID > 0) {
          const quotationDetail = await fetchQuotationDetail(QuotationID);
          if (quotationDetail[0].FK_Issue_ID > 0 || quotationDetail[0].FK_SalesOrder_ID > 0) {
            Swal.fire(
              'Error!',
              'Sales Order or Service job already exist for the selected quotation.',
              'warning'
            );
          }
          else {

            const result = await Swal.fire({
              title: 'Are you sure?',
              text: "Create invoice from the selected quotation!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Create it!'
            });

            if (result.isConfirmed) {
              setLoading(true);
              try {

                if (quotationDetail[0].OpportunityID > 0) {
                  const Customer = await CreateCustomer(event, quotationDetail[0].OpportunityID, "0");
                  const CustomerID = Customer.CustomerID;

                }


                const message = await handleInvoice(event, QuotationID);
                if (message === "Data Saved") {
                  Swal.fire(
                    'Success!',
                    'Invoice Created Successfully.',
                    'warning'
                  );
                  await fetchQuotation("0", pageSize);
                }
              }
              catch (error) {
                console.error('Error fetching Teams:', error);
              }
              finally {
                setLoading(false); // Stop loading after fetching
              }
            }

          }
        }
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to create an invoice.',
        'warning'
      );
    }


  };

  return (

    <div>
      {ClientCompanyID === 0 && LeadID === 0 && OpportunityID === 0 && (
        <Common showAddButton={'yes'} handleAddTask={handleCreateQuotationClick}
          showReportButton={'yes'} handleReports={generatePDF}
          showServiceJob={'yes'} handleServiceJob={handleCreateServiceJob}
          showSaleOrder={'yes'} handleSaleOrder={handleCreateSaleOrder}
          showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick}
          ModuleID={"6"}
          showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
          showExportButton={'yes'} handleExportExcel={handleExportExcel}
          showPrintUser={'yes'} handlePrintUser={handlePrintUser}
          IsAttachment="1"
          isDisabled={multipleIds.length > 1}
          HelpFormName="Quotation List" HelpModule="7"
          showInvoiceButton={'yes'} handleInvoiceCreate={handleCreateInvoice}
          RecordID={multipleIds} />
      )}
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row mb-3" style={{ marginLeft: "-5px" }}>
          {(ClientCompanyID === 0 && LeadID === 0 && OpportunityID === 0 &&
            <div className="col-xl-2">
              <h1>{t('title')}</h1>
            </div>
          )}
          {((ClientCompanyID > 0 || LeadID > 0 || OpportunityID > 0) &&
            <div className="col-xl-2">
              <button className='btn btn-primary btn-sm' onClick={handleCreateQuotationClick}>
                <i className="icofont-plus" aria-hidden="true"> {t('createQuotation')}</i>
              </button>
            </div>
          )}



          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />

          </div>
        </div>
      </div>
      <div className="row mb-3" style={{ marginLeft: "-5px" }}>
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="">
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table className="table m-0 table-hover" ref={tableRef} style={{ "width": "100%", tableLayout: "fixed" }}>
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th style={{ width: "3%" }}></th>
                        {visibleColumns.includes("QquotationNo") && <th
                          onClick={() => handleSort('QquotationNo')}
                          style={{
                            width: `${columnWidths?.quotationNo}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('quotationNo')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "quotationNo");
                            }}
                            onDoubleClick={() => autoFitColumn("quotationNo")}

                          /></th>}
                        {visibleColumns.includes("QquotationDate") && <th
                          onClick={() => handleSort('QquotationDate')}
                          style={{
                            width: `${columnWidths?.quotationDate}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('quotationDate')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "quotationDate");
                            }}
                            onDoubleClick={() => autoFitColumn("quotationDate")}

                          /></th>}
                        {visibleColumns.includes("Qstatus") && <th
                          onClick={() => handleSort('Qstatus')}
                          style={{
                            width: `${columnWidths?.status}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('status')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "status");
                            }}
                            onDoubleClick={() => autoFitColumn("status")}
                          /></th>}
                        {visibleColumns.includes("Qtype") && <th
                          onClick={() => handleSort('Qtype')}
                          style={{
                            width: `${columnWidths?.type}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('type')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "type");
                            }}
                            onDoubleClick={() => autoFitColumn("type")}

                          /></th>}
                        {visibleColumns.includes("Qcustomer") && <th
                          onClick={() => handleSort('Qcustomer')}
                          style={{
                            width: `${columnWidths?.customer}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Company<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "customer");
                            }}
                            onDoubleClick={() => autoFitColumn("customer")}

                          /></th>}
                        {visibleColumns.includes("QSiteName") &&
                          <th onClick={() => handleSort('SiteName')}

                            style={{
                              width: `${columnWidths?.SiteName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Site<i
                              className={`ms-1 icofont ${sortConfig.key === 'SiteName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SiteName");
                              }}
                              onDoubleClick={() => autoFitColumn("SiteName")}
                            /></th>
                        }
                        {visibleColumns.includes("Qemail") && <th
                          onClick={() => handleSort('Qemail')}
                          style={{
                            width: `${columnWidths?.Email}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Email<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "Email");
                            }}
                            onDoubleClick={() => autoFitColumn("Email")}
                          /></th>}
                        {visibleColumns.includes("Qaddress") && <th
                          onClick={() => handleSort('Qaddress')}
                          style={{
                            width: `${columnWidths?.address}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('address')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "address");
                            }}
                            onDoubleClick={() => autoFitColumn("address")}
                          /></th>}
                        {visibleColumns.includes("QsalesNo") && <th
                          onClick={() => handleSort('QsalesNo')}
                          style={{
                            width: `${columnWidths?.salesNo}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('salesNo')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "salesNo");
                            }}
                            onDoubleClick={() => autoFitColumn("salesNo")}
                          /></th>}
                        {visibleColumns.includes("QjobNo") && <th
                          onClick={() => handleSort('QjobNo')}
                          style={{
                            width: `${columnWidths?.jobNo}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('jobNo')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "jobNo");
                            }}
                            onDoubleClick={() => autoFitColumn("jobNo")}
                          /></th>}
                        {visibleColumns.includes("Qtotal") && <th
                          onClick={() => handleSort('Qtotal')}
                          style={{
                            width: `${columnWidths?.total}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('total')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "total");
                            }}
                            onDoubleClick={() => autoFitColumn("total")}
                          /></th>}
                        {visibleColumns.includes("AssignTo") &&
                          <th onClick={() => handleSort('AssignTo')}

                            style={{
                              width: `${columnWidths?.AssignTo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Assign To
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AssignTo");
                              }}
                              onDoubleClick={() => autoFitColumn("AssignTo")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {QuotationList.map((quotation, index) => (

                        <tr key={quotation.PK_Quotation_ID} onClick={() => handleEditClick(quotation.PK_Quotation_ID, quotation.type)}
                          style={{
                            backgroundColor: selectedId.toString() === quotation.PK_Quotation_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}
                        >

                          <td className="no-wrap">
                            {OpportunityID > 0 ? (
                              <select
                                className="form-control"
                                id={`dropdown-${quotation.PK_Quotation_ID}`}
                                value={quotation.ConvertType.toString()} // Ensure this value is fetched correctly
                                onChange={(event) => handleDropdownChange(event, quotation.PK_Quotation_ID)}
                                onClick={(event) => event.stopPropagation()}
                              >
                                <option value="-1">Select</option>
                                <option value="0">Sale Order</option>
                                <option value="1">Service Job</option>
                              </select>
                            ) : (
                              <div
                                className="gmail-checkbox-wrapper"
                                onClick={(event) => event.stopPropagation()}  // Prevent row click
                              >
                                <input
                                  type="checkbox"
                                  className="gmail-checkbox"
                                  checked={multipleIds.includes(quotation.PK_Quotation_ID)}
                                  onChange={(event) =>
                                    handleCheckboxClick(
                                      event,
                                      quotation.PK_Quotation_ID,
                                      index,
                                      quotation.type
                                    )
                                  }
                                />
                              </div>
                            )}
                          </td>



                          {visibleColumns.includes("QquotationNo") && <td style={{
                            width: columnWidths.quotationNo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{quotation.bnt_OrderNumber}</td>}
                          {visibleColumns.includes("QquotationDate") && <td style={{
                            width: columnWidths.quotationDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(quotation.dt_QuotationDate)}</td>}
                          {visibleColumns.includes("Qstatus") && <td style={{
                            width: columnWidths.status,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={quotation.vc_StatusName}>{quotation.vc_StatusName}</td>}
                          {visibleColumns.includes("Qtype") &&
                            <td style={{
                              width: columnWidths.type,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {
                                { 1: "Customer", 2: "Lead", 3: "Opportunity" }[quotation.type] || "Unknown"
                              }
                            </td>
                          }
                          {visibleColumns.includes("Qcustomer") && <td style={{
                            width: columnWidths.customer,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={quotation.CompanyName}>{quotation.CompanyName}</td>}

                          {visibleColumns.includes("QSiteName") && <td style={{
                            width: columnWidths.SiteName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={quotation.SiteName}>{quotation.SiteName}</td>}

                          {visibleColumns.includes("Qemail") && <td style={{
                            width: columnWidths.Email,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={quotation.Email}>
                            <a href='#' onClick={(event) => handleEmailClick(event, quotation)}>
                              {quotation.Email}
                            </a>
                          </td>}

                          {visibleColumns.includes("Qaddress") && <td style={{
                            width: columnWidths.address,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={quotation.vc_Address1}>{quotation.vc_Address1}</td>}
                          {visibleColumns.includes("QsalesNo") && <td style={{
                            width: columnWidths.salesNo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{quotation.SaleOrderNo}</td>}
                          {visibleColumns.includes("QjobNo") && <td style={{
                            width: columnWidths.jobNo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{quotation.JobNo}</td>}
                          {visibleColumns.includes("Qtotal") && <td style={{
                            width: columnWidths.total,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{quotation.BaseCurrency}{parseFloat(quotation.Total).toFixed(2)}</td>}
                          {visibleColumns.includes("AssignTo") && <td style={{
                            width: columnWidths.AssignTo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {quotation.AssignTo ? (
                              <div
                                title={quotation.AssignTo}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {quotation.AssignTo.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {quotation.ModifiedBy ? (
                              <div
                                title={quotation.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {quotation.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(quotation.UpdatedDate, activeDateFormat)}  </td>}
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                </div>
                {isModalOpen && (
                  <QuotationDetailModal QuotationID={localStorage.getItem('QuotationID')} onClose={handleCloseModal} onSuccess={handleSuccess} ClientCompanyID={ClientCompanyID} CustomerType={localStorage.getItem('CustomerType')} LeadID={LeadID} OpportunityID={OpportunityID} MainPage={MainPage} />
                )}

              </div>
            </div>
          </div>
        </div>
      </div>

      {isEmailModalOpen && (
        <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={ContactIDForEmail} />
      )}
      {isMultipleEmailModalOpen && (
        <SendAttachment onClose={handleCloseEmailModal} ToEmail={Email} pdfAttachment={pdfAttachment} ReportName="Quotation.pdf" />
      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}

    </div>


  );
}
export default QuotationList;

